import {
  Query,
  SelfFundedOfferDetailsResultTypenames,
  SelfFundedOfferDetailsSuccess,
} from '@varo/graphql-schema-types';
import getSelfFundedOfferDetailsV2 from 'services/graphql/queries/rewards/GetSelfFundedOfferDetailsV2';
import { CombinedError, useQuery } from 'urql';

type SelfFundedOfferDetailsV2 = SelfFundedOfferDetailsSuccess & {
  offerTitle?: string;
  statusText?: string;
  expirationText?: string;
  instructions?: Array<{
    id: string;
    icon?: string;
    text: string;
  }>;
};

const useSelfFundedOffersDetailsV2 = (offerId: string) => {
  const [{ data, fetching: loading, error }] = useQuery<Query>({
    query: getSelfFundedOfferDetailsV2,
    variables: {
      input: {
        offerId: offerId,
      },
    },
    requestPolicy: 'cache-and-network',
  });

  let offersData: SelfFundedOfferDetailsV2 | null = null;
  let errorData: CombinedError | null = null;

  if (error) {
    errorData = error;
  } else if (data?.selfFundedOfferDetails) {
    if (
      data.selfFundedOfferDetails.__typename ===
      SelfFundedOfferDetailsResultTypenames.SelfFundedOfferDetailsSuccess
    ) {
      offersData = data.selfFundedOfferDetails as SelfFundedOfferDetailsV2;
    } else if (
      data.selfFundedOfferDetails.__typename ===
      SelfFundedOfferDetailsResultTypenames.SelfFundedOfferDetailsError
    ) {
      errorData = {
        name: data.selfFundedOfferDetails.title,
        message: data.selfFundedOfferDetails.message,
        graphQLErrors: [],
      };
    }
  }

  return {
    offersData,
    loading,
    errorData,
  };
};

export default useSelfFundedOffersDetailsV2;
